export default "/images/205e8843602a64b1355c6639eb801d97.avif";